import { GET_USER_GROUP, UPDATE_SELECTED_DEALER } from '../types';

export default (state = {}, action) => {
  switch (action.type) {
    case GET_USER_GROUP:
      return {
        ...state,
        userGroup: action.payload,
      };
    case UPDATE_SELECTED_DEALER:
      return {
        ...state,
        selectedDealer: action.payload.dealerId
      }
    default:
      return state;
  }
};
